//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UniqueColumnRowByIdDataSourceCache: FeatureFlag = {"Id":"UniqueColumnRowByIdDataSourceCache","Label":"(KILL)[10.24]UniqueColumnRowByIdDataSourceCache","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Cache datasource lookups for schemas with a unique column as row-by-id entries and serve simple unique-column equality lookups from that row cache.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
